import { atom } from "recoil";


const productViewStatus = atom({
  key: 'productViewStatus', 
  default: false, 
 });


 export default productViewStatus;
